import styled from 'styled-components';
import { colors, s24 } from '@ardoq/design-tokens';

const SettingsBarSeparator = styled.div`
  width: 1px;
  height: ${s24};
  border-radius: 1px;
  background-color: ${colors.grey300};
`;
export { SettingsBarSeparator };
